import domain from "../domain";
import { useEffect, useState } from "react";
import { useInteractionLog } from "./useInteractionLog";

export type StatusType = "idle" | "pending" | "success" | "error";
export type DomainType = typeof domain;
export type RunType = (domain: DomainType) => Promise<any>;

const useDomain = ({
  initRun,
  initState = null,
}: {
  initRun?: RunType;
  initState?: any;
} = {}) => {
  const [data, setData] = useState(initState);
  const [status, setStatus] = useState<StatusType>("idle");
  const [error, setError] = useState<any>(null);
  const { saveDataLog } = useInteractionLog();
  const executeUseCase = async (run: RunType) => {
    let response = null;
    let error = null;
    setStatus("pending");
    setError(null);

    try {
      response = await run(domain);
      if (response) {
        setData(response);
        setStatus("success");
      } else {
        error = "error";
        setStatus("error");
        setError("error");
      }
    } catch (e: any) {
      const idTransaction = e?.response?.data?.idTransaction;
      const message = e?.response?.data?.message;
      const path = window.location.pathname;
      const status: number = e?.response?.status;
      if (idTransaction) {
        localStorage.setItem("DTransaction", idTransaction);
        localStorage.setItem("DTransaction_status", status.toString());
        saveDataLog({idTransaction, message, path, status });
      } else {
        localStorage.setItem("DTransaction", "NOT_FOUND");
        localStorage.setItem("DTransaction_status", status?.toString());
      }
      setStatus("error");
      setError(e);
      error = e;
    }

    return { data: response, error: error };
  };

  useEffect(() => {
    if (initRun) executeUseCase(initRun);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const clearError = (newState?: any) => {
    setStatus("idle");
    setError(null);
    setData(newState);
  };

  return {
    isIdle: status === "idle",
    isLoading: status === "pending",
    isError: status === "error",
    isSuccess: status === "success",
    status,
    error,
    data,
    run: executeUseCase,
    clearError,
  };
};

export default useDomain;
